var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7019_27586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20.4134C15.5229 20.4134 20 16.0606 20 10.6911C20 5.32159 15.5229 0.96875 10 0.96875C4.47716 0.96875 0 5.32159 0 10.6911C0 16.0606 4.47716 20.4134 10 20.4134Z",
    fill: "#3B76BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.6912C20 16.0385 15.5 20.4136 10 20.4136C6.81253 20.4136 4.00002 19.016 2.1875 16.7677C3.875 18.1045 6.06251 18.8945 8.43749 18.8945C13.9375 18.8945 18.4375 14.5194 18.4375 9.17214C18.4375 6.86311 17.625 4.73634 16.25 3.0957C18.5625 4.85781 20 7.59221 20 10.6912Z",
    fill: "#21577B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.438 7.89509L8.93796 14.8223C8.50044 15.3084 7.75047 15.3084 7.31295 14.8223L4.56294 11.8448C4.18796 11.4194 4.18796 10.751 4.62543 10.3257C5.06295 9.9611 5.75043 9.9611 6.18795 10.3864L8.12546 12.5132L13.8129 6.49751C14.2505 6.07214 14.9379 6.01139 15.3755 6.43676C15.8129 6.80133 15.8129 7.53052 15.438 7.89509Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7019_27586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.4446,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.30c72d3c2947d2e86825882e51e7a016.svg";
export { ForwardRef as ReactComponent };